import DeleteArticle from './deleteArticle';
import ArticleListItems from './articlelistitems';
import SeriesportRedirect from './SeriesportRedirect';

SeriesportRedirect.Register();
DeleteArticle.register();
ArticleListItems();
